import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ShowsAt from '../../ShowAt/ShowAt';
import './Tags.scss';

const Tags = ({ tags = '' }) => {
  const renderedTags = useMemo(() => tags?.split(',').filter((tag) => tag), [tags]);
  return (
    <ShowsAt at={!!renderedTags?.length}>
      <div className="pool-legend-tags">
        {renderedTags?.map((tag) => (
          <span key={tag}>{tag}</span>
        ))}
      </div>
    </ShowsAt>
  );
};

Tags.defaultProps = {
  tags: '',
};

Tags.propTypes = {
  tags: PropTypes.string,
};

export default Tags;
